@if (point()) {
    <div
        *transloco="let t"
        #tooltip
        class="bazis-coordinates"
        (click)="copy($event)"
    >
        <!-- широта, долгота -->
        <span>
            {{ point().coordinates[1] | localNumber: '1.0-6' }},&nbsp;
            {{ point().coordinates[0] | localNumber: '1.0-6' }}
        </span>

        @if (canCopy()) {
            <bazis-icon
                slot="icon-only"
                [name]="icons.coordinatesCopy"
                color="action"
            ></bazis-icon>
            <bazis-tooltip
                [reference]="tooltip"
                placement="top"
                [isStatic]="true"
                [watchChange]="true"
                class="bh-popper-z-index"
            >
                {{ t(tooltipKey(), tooltipParams) }}
            </bazis-tooltip>
        }
    </div>
}
